import { render, staticRenderFns } from "./AdminRequestsDetailsView.vue?vue&type=template&id=a9d5320e&scoped=true"
import script from "./AdminRequestsDetailsView.vue?vue&type=script&lang=js"
export * from "./AdminRequestsDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d5320e",
  null
  
)

export default component.exports